import { render } from "./Button.vue?vue&type=template&id=33a02f6e&scoped=true"
const script = {}

import "./Button.vue?vue&type=style&index=0&id=33a02f6e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a02f6e"]])

export default __exports__